import React, { useState } from "react";
import { Table, Form, Button, Modal } from "react-bootstrap";

const SYMBOL_MAP = {
  High: "-",
  Low: "+",
  Unclear: "?",
  Concerns: "?",
  Err: "Err",
};

const DOWNLOAD_FILE_NAME = "risk_of_bias.txt";

export default function RiskOfBiasTable({
  riskOfBiasMap,
  setRiskOfBiasMap,
  parsedData,
  robType,
}) {
  const [showModal, setShowModal] = useState(false);
  const [currentThought, setCurrentThought] = useState("");
  const [currentStudyName, setCurrentStudyName] = useState("");
  const [downloading, setDownloading] = useState(false);

  const biasLabels = ["A", "B", "C", "D", "E"];
  const RISK_OPTIONS = [
    "High",
    "Low",
    robType === "ROB1" ? "Unclear" : "Concerns",
    "Err",
  ];

  const handleChange = (studyId, biasIndex, value) => {
    setRiskOfBiasMap((prev) =>
      prev.map((rob) =>
        rob.id === studyId
          ? {
              ...rob,
              values: rob.values.map((v, i) => (i === biasIndex ? value : v)),
            }
          : rob
      )
    );
  };

  const handleShowThought = (rob) => {
    const study = parsedData.find((s) => s.id === rob.id);
    setCurrentStudyName(study?.name || "Unknown Study");
    setCurrentThought(rob.thought || "No reasoning provided.");
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentThought("");
    setCurrentStudyName("");
  };

  // --------------------------
  //   DOWNLOAD TXT FUNCTION
  // --------------------------
  const handleDownloadTxt = () => {
    let txt = "";

    riskOfBiasMap.forEach((rob) => {
      const study = parsedData.find((s) => s.id === rob.id);
      const name = study?.name || rob.id;

      txt += `- study: ${name}\n`;

      biasLabels.forEach((label, idx) => {
        txt += `  ${label}: ${rob.values[idx]}\n`;
      });

      txt += "\n";
    });

    const blob = new Blob([txt], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = DOWNLOAD_FILE_NAME;
    link.click();

    URL.revokeObjectURL(url);

    setDownloading(true);
    setTimeout(() => setDownloading(false), 1700);
  };

  return (
    <>
      <Table bordered hover responsive className="mt-3">
        <thead>
          <tr>
            <th>Study Name</th>

            {biasLabels.map((label) => (
              <th key={label}>Bias {label}</th>
            ))}

            <th className="text-center">
              <Button
                className="logo-color"
                size="sm"
                onClick={handleDownloadTxt}
                title="Download TXT"
              >
                {downloading ? "✓ Done!" : "Export 📋"}
              </Button>
            </th>
          </tr>
        </thead>

        <tbody>
          {riskOfBiasMap.map((rob) => {
            const study = parsedData.find((s) => s.id === rob.id);
            return (
              <tr key={rob.id}>
                <td>{study?.name || rob.id}</td>

                {rob.values.map((v, i) => (
                  <td key={i}>
                    <Form.Select
                      size="sm"
                      value={v}
                      onChange={(e) => handleChange(rob.id, i, e.target.value)}
                    >
                      {RISK_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt} ({SYMBOL_MAP[opt.trim()]})
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                ))}

                <td className="text-center">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => handleShowThought(rob)}
                  >
                    Reasoning
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton className="logo-color text-white">
          <Modal.Title>Reasoning for: {currentStudyName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ whiteSpace: "pre-wrap" }}>{currentThought}</pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
